<script lang="ts">
  // The home screen is the catalog, and nothing else. It is public — a visitor browses without
  // signing in — with the account state and every account action in the application header (App.svelte).
  // Downloading a family (from a card's detail) is what requires a session.

  import LibraryBrowser from "@/catalog/LibraryBrowser.svelte";
</script>

<div class="max-w-6xl mx-auto">
  <LibraryBrowser />
</div>
